import {accountApi} from '../api/AccountApi';
import Logger from '../util/Logger';

export const popTooltips = {
  popinTabReminder: () => {
    return accountApi.getClientInfo().then(stash => {
      const info = stash || {};
      Logger.info("client_info: ", info);

      // we don't need this stash, just returning something so that we can chain off the promise in the UI, to handle errors
      return stash;
    })
  }
};
